<div class="testemunhos-container">
  <!-- ════ BARRA DE FILTROS & AÇÕES (ADMIN EXCLUSIVO) ════ -->
  <div class="filter-actions-bar">
    <div class="filters-group">
      <!-- Pesquisa por descrição -->
      <div class="filter-input-wrap">
        <i class="fas fa-search filter-icon"></i>
        <input
          type="text"
          pInputText
          [(ngModel)]="filterText"
          (keyup.enter)="applyFilter()"
          placeholder="Pesquisar por conteúdo..."
          class="filter-search-input"
        />
        <button
          *ngIf="filterText"
          type="button"
          class="clear-input-btn"
          (click)="filterText = ''; applyFilter()"
          title="Limpar pesquisa"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Filtro por Estrelas -->
      <div class="filter-select-wrap">
        <p-select
          [options]="estrelasFilterOptions"
          [(ngModel)]="filterEstrelas"
          (onChange)="applyFilter()"
          optionLabel="label"
          optionValue="value"
          placeholder="Estrelas"
          styleClass="filter-select"
          appendTo="body"
        ></p-select>
      </div>

      <!-- Filtro por Estado (Ativo/Inativo) -->
      <div class="filter-select-wrap">
        <p-select
          [options]="ativoFilterOptions"
          [(ngModel)]="filterAtivo"
          (onChange)="applyFilter()"
          optionLabel="label"
          optionValue="value"
          placeholder="Estado"
          styleClass="filter-select"
          appendTo="body"
        ></p-select>
      </div>

      <!-- Botão Aplicar / Limpar -->
      <button
        *ngIf="filterText || filterEstrelas !== null || filterAtivo !== null"
        type="button"
        class="btn-reset-filters"
        (click)="clearFilters()"
        title="Limpar todos os filtros"
      >
        <i class="fas fa-undo-alt"></i> Limpar
      </button>
    </div>

    <!-- Botão de Ação Primária -->
    <div class="action-btn-wrap">
      <button
        type="button"
        class="btn-primary-action"
        (click)="openCreateDialog()"
      >
        <i class="fas fa-plus"></i>
        <span>Novo Testemunho</span>
      </button>
    </div>
  </div>

  <!-- ════ LISTA DE TESTEMUNHOS ════ -->
  <div *ngIf="loading" class="loading-state">
    <i class="fas fa-spinner fa-spin loading-spinner"></i>
    <span>A carregar testemunhos...</span>
  </div>

  <ng-container *ngIf="!loading">
    <div *ngIf="testemunhos.length > 0; else noDataBlock" class="testemunhos-grid">
      <div
        class="testemunho-admin-card"
        *ngFor="let item of testemunhos"
        [class.is-inactive]="!item.ativo"
      >
        <!-- Header do Card: Utilizador + Status Badge -->
        <div class="card-top">
          <div class="user-meta">
            <div class="user-avatar-initials">
              {{ getUserInitials(item.utilizadorNome || item.utilizadorNomeAnonimo) }}
            </div>
            <div class="user-info-text">
              <div class="user-name-row">
                <h4 class="user-fullname">{{ item.utilizadorNome || item.utilizadorNomeAnonimo || 'Utilizador' }}</h4>
                <span *ngIf="item.utilizadorAnonimo" class="badge-anonimo">
                  <i class="fas fa-user-secret"></i> Anónimo
                </span>
              </div>
              <span class="user-email" *ngIf="item.utilizadorEmail">{{ item.utilizadorEmail }}</span>
              <span class="created-date" *ngIf="item.dataCriacao">
                <i class="far fa-calendar-alt"></i> {{ item.dataCriacao | date:'dd/MM/yyyy HH:mm' }}
              </span>
            </div>
          </div>

          <!-- Status Badge -->
          <div class="status-badge" [class.badge-active]="item.ativo" [class.badge-inactive]="!item.ativo">
            <i class="fas" [ngClass]="item.ativo ? 'fa-check-circle' : 'fa-minus-circle'"></i>
            <span>{{ item.ativo ? 'Ativo' : 'Inativo' }}</span>
          </div>
        </div>

        <!-- Estrelas -->
        <div class="stars-display">
          <i class="fas fa-star star-filled" *ngFor="let _ of getStarsArray(item.estrelas)"></i>
          <i class="far fa-star star-empty" *ngFor="let _ of getEmptyStarsArray(item.estrelas)"></i>
          <span class="stars-number">({{ item.estrelas }}/5)</span>
        </div>

        <!-- Descrição -->
        <div class="card-quote">
          <i class="fas fa-quote-left quote-icon"></i>
          <p class="quote-text">{{ item.descricao }}</p>
        </div>

        <!-- Rodapé do Card com Ações -->
        <div class="card-actions-footer">
          <div class="actions-left">
            <button
              type="button"
              class="card-action-btn btn-view"
              (click)="openDetailDialog(item)"
              title="Ver Detalhes"
            >
              <i class="fas fa-eye"></i> Detalhes
            </button>
            <button
              type="button"
              class="card-action-btn btn-edit"
              (click)="openEditDialog(item)"
              title="Editar Testemunho"
            >
              <i class="fas fa-edit"></i> Editar
            </button>
          </div>

          <div class="actions-right">
            <!-- Toggle Ativo/Inativo -->
            <button
              type="button"
              class="card-action-btn"
              [class.btn-deactivate]="item.ativo"
              [class.btn-activate]="!item.ativo"
              (click)="toggleStatus(item)"
              [title]="item.ativo ? 'Desativar Testemunho' : 'Ativar Testemunho'"
            >
              <i class="fas" [ngClass]="item.ativo ? 'fa-ban' : 'fa-check'"></i>
              <span>{{ item.ativo ? 'Desativar' : 'Ativar' }}</span>
            </button>

            <!-- Excluir -->
            <button
              type="button"
              class="card-action-btn btn-delete"
              (click)="deleteTestemunho(item)"
              title="Eliminar Testemunho"
            >
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginação -->
    <div *ngIf="testemunhos.length > 0" class="pagination-controls">
      <app-paginator-control
        [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
        [rows]="pagination.pageSize ?? 10"
        [totalRecords]="pagination.totalRecords ?? 0"
        (pageChange)="onPageChange($event)"
      >
      </app-paginator-control>
    </div>

    <!-- Sem Dados -->
    <ng-template #noDataBlock>
      <div class="no-data-wrapper">
        <app-data-void
          titulo="Nenhum testemunho encontrado"
          descricao="Não foram encontrados registos para os filtros aplicados. Clique no botão 'Novo Testemunho' para adicionar o primeiro."
        ></app-data-void>
      </div>
    </ng-template>
  </ng-container>
</div>

<!-- ════ MODAL CRIAR / EDITAR TESTEMUNHO ════ -->
<p-dialog
  [header]="isEditing ? 'Editar Testemunho' : 'Novo Testemunho'"
  [(visible)]="showFormDialog"
  [modal]="true"
  [style]="{ width: '560px', maxWidth: '95vw' }"
  [closable]="true"
  (onHide)="closeFormDialog()"
>
  <form [formGroup]="formTestemunho" (ngSubmit)="saveTestemunho()" class="modal-form">
    <!-- Seletor de Estrelas Interativo -->
    <div class="form-field">
      <label class="field-label">Classificação (Estrelas) <span class="required">*</span></label>
      <div class="interactive-stars">
        <button
          type="button"
          class="star-btn"
          *ngFor="let s of [1, 2, 3, 4, 5]"
          (click)="setStars(s)"
        >
          <i
            class="fa-star"
            [ngClass]="s <= formTestemunho.get('estrelas')?.value ? 'fas text-amber-500' : 'far text-slate-300'"
          ></i>
        </button>
        <span class="stars-score-label">
          <strong>{{ formTestemunho.get('estrelas')?.value }}</strong> de 5 estrelas
        </span>
      </div>
    </div>

    <!-- Seleção de Utilizador -->
    <div class="form-field">
      <label class="field-label">Utilizador / Autor <span class="required">*</span></label>
      <p-select
        [options]="utilizadoresOptions"
        formControlName="utilizadorID"
        optionLabel="label"
        optionValue="value"
        placeholder="Selecione o autor do testemunho"
        styleClass="w-full"
        [filter]="true"
        filterBy="label"
        appendTo="body"
      ></p-select>
      <small
        class="field-error"
        *ngIf="formTestemunho.get('utilizadorID')?.invalid && formTestemunho.get('utilizadorID')?.touched"
      >
        A seleção do utilizador é obrigatória.
      </small>
    </div>

    <!-- Descrição / Depoimento -->
    <div class="form-field">
      <label class="field-label">Depoimento / Descrição <span class="required">*</span></label>
      <textarea
        rows="4"
        pInputText
        formControlName="descricao"
        placeholder="Partilhe a experiência ou o impacto alcançado com a FundCube..."
        class="form-textarea w-full"
      ></textarea>
      <div class="field-helper-row">
        <small
          class="field-error"
          *ngIf="formTestemunho.get('descricao')?.invalid && formTestemunho.get('descricao')?.touched"
        >
          A descrição é obrigatória (mínimo de 5 caracteres).
        </small>
        <span class="char-counter">
          {{ formTestemunho.get('descricao')?.value?.length || 0 }} / 1000
        </span>
      </div>
    </div>

    <!-- Botões de Ação do Modal -->
    <div class="modal-footer-actions">
      <button
        type="button"
        class="btn-cancel"
        (click)="closeFormDialog()"
      >
        Cancelar
      </button>
      <button
        type="submit"
        class="btn-submit"
        [disabled]="saving || formTestemunho.invalid"
      >
        <i *ngIf="saving" class="fas fa-spinner fa-spin mr-1"></i>
        <i *ngIf="!saving" class="fas fa-save mr-1"></i>
        <span>{{ isEditing ? 'Atualizar Testemunho' : 'Guardar Testemunho' }}</span>
      </button>
    </div>
  </form>
</p-dialog>

<!-- ════ MODAL DETALHES DO TESTEMUNHO ════ -->
<p-dialog
  header="Detalhes do Testemunho"
  [(visible)]="showDetailDialog"
  [modal]="true"
  [style]="{ width: '600px', maxWidth: '95vw' }"
  [closable]="true"
  (onHide)="closeDetailDialog()"
>
  <div *ngIf="selectedTestemunho" class="detail-modal-body">
    <!-- Header com autor -->
    <div class="detail-header-card">
      <div class="user-avatar-initials large">
        {{ getUserInitials(selectedTestemunho.utilizadorNome || selectedTestemunho.utilizadorNomeAnonimo) }}
      </div>
      <div class="detail-header-info">
        <div class="flex items-center gap-2">
          <h3 class="detail-author-name">
            {{ selectedTestemunho.utilizadorNome || selectedTestemunho.utilizadorNomeAnonimo || 'Utilizador' }}
          </h3>
          <span *ngIf="selectedTestemunho.utilizadorAnonimo" class="badge-anonimo">
            <i class="fas fa-user-secret"></i> Anónimo
          </span>
        </div>
        <p class="detail-author-email" *ngIf="selectedTestemunho.utilizadorEmail">
          <i class="far fa-envelope"></i> {{ selectedTestemunho.utilizadorEmail }}
        </p>
        <p class="detail-author-id" *ngIf="selectedTestemunho.utilizadorID">
          <i class="fas fa-id-badge"></i> ID: {{ selectedTestemunho.utilizadorID }}
        </p>
      </div>

      <div class="status-badge" [class.badge-active]="selectedTestemunho.ativo" [class.badge-inactive]="!selectedTestemunho.ativo">
        <i class="fas" [ngClass]="selectedTestemunho.ativo ? 'fa-check-circle' : 'fa-minus-circle'"></i>
        <span>{{ selectedTestemunho.ativo ? 'Ativo' : 'Inativo' }}</span>
      </div>
    </div>

    <!-- Informações Chave -->
    <div class="detail-grid-info">
      <div class="info-block">
        <span class="info-label"><i class="fas fa-hashtag"></i> ID do Registo</span>
        <span class="info-val">#{{ selectedTestemunho.id }}</span>
      </div>
      <div class="info-block">
        <span class="info-label"><i class="far fa-calendar-alt"></i> Data de Criação</span>
        <span class="info-val">{{ (selectedTestemunho.dataCriacao | date:'dd/MM/yyyy HH:mm') || '—' }}</span>
      </div>
      <div class="info-block">
        <span class="info-label"><i class="fas fa-star text-amber-500"></i> Avaliação</span>
        <span class="info-val flex items-center gap-1">
          <i class="fas fa-star text-amber-500" *ngFor="let _ of getStarsArray(selectedTestemunho.estrelas)"></i>
          <i class="far fa-star text-slate-300" *ngFor="let _ of getEmptyStarsArray(selectedTestemunho.estrelas)"></i>
          <strong class="ml-1">({{ selectedTestemunho.estrelas }}/5)</strong>
        </span>
      </div>
      <div class="info-block">
        <span class="info-label"><i class="fas fa-toggle-on"></i> Estado Atual</span>
        <span class="info-val font-semibold" [class.text-emerald-600]="selectedTestemunho.ativo" [class.text-rose-600]="!selectedTestemunho.ativo">
          {{ selectedTestemunho.ativo ? 'Publicado e Visível' : 'Desativado (Oculto)' }}
        </span>
      </div>
    </div>

    <!-- Conteúdo Completo -->
    <div class="detail-content-box">
      <h5 class="content-box-title"><i class="fas fa-comment-alt"></i> Conteúdo do Testemunho</h5>
      <p class="content-box-text">"{{ selectedTestemunho.descricao }}"</p>
    </div>

    <!-- Ações no modal de detalhes -->
    <div class="modal-footer-actions mt-4">
      <button type="button" class="btn-cancel" (click)="closeDetailDialog()">
        Fechar
      </button>
      <button
        type="button"
        class="btn-edit"
        (click)="closeDetailDialog(); openEditDialog(selectedTestemunho)"
      >
        <i class="fas fa-edit mr-1"></i> Editar Testemunho
      </button>
    </div>
  </div>
</p-dialog>
